export const TRIAL_BANNER_ID = 'trial-banner-render-to';